exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".payoff-adjustment-text>*[data-v-06c73d9c]{margin-bottom:30px;left:-2px;position:relative}.payoff-adjustment-text .text[data-v-06c73d9c]{margin-bottom:0;font-weight:600;font-family:Open Sans,sans-serif;font-size:14px;font-weight:400;font-style:normal;font-stretch:normal;line-height:1.57;letter-spacing:normal;text-align:left;color:#282828}.payoff-adjustment-text .title[data-v-06c73d9c]{font-weight:700}", ""]);

// exports
